<div class="modal-container mt-3 d-flex flex-column">

    <h4>Topup</h4>

    <div class="field d-flex align-items-center mb-3 mt-3" *ngIf="loadFundsForm.controls.amount">
        <p class="account-fund-field-label">Amount to be Loaded</p>
        <div class="account-fund-field-input">
            <app-value-field [editMode]="true">
                <app-value-field-input
                    [controlDisplayName]="'Amount to be loaded'"
                    [control]="loadFundsForm.controls.amount"
                    appValueField="editField"
                    inputType="number"
                    placeholder="Enter amount"
                ></app-value-field-input>
            </app-value-field>
        </div>
    </div>

    <div class="field d-flex align-items-center mb-3" *ngIf="loadFundsForm.controls.currency">
        <p class="account-fund-field-label">Currency</p>
        <div class="account-fund-field-input">
            <app-value-field [editMode]="true">
                <app-value-field-select
                    [control]="loadFundsForm.controls.currency"
                    appValueField="editField"
                    controlDisplayName="Currency"
                    placeholder="Select currency"
                >
                    <ng-template *ngFor="let currency of currencies" [appValueFieldOption]="currency">
                        <span>{{ currency }}</span>
                    </ng-template>
                </app-value-field-select>
            </app-value-field>
        </div>
    </div>

    <div class="field d-flex align-items-center mb-3" *ngIf="loadFundsForm.controls.note">
        <p class="account-fund-field-label">Comments</p>
        <div class="account-fund-field-input">
            <app-value-field [editMode]="true">
                <app-value-field-input
                    [controlDisplayName]="'Comments'"
                    [control]="loadFundsForm.controls.note"
                    appValueField="editField"
                    placeholder="Enter comments"
                ></app-value-field-input>
            </app-value-field>
        </div>
    </div>

    <div class="footer d-flex justify-content-end align-items-center mt-4">
        <button
            class="rounded-pill me-2 topup-btn"
            [class.button-spinner]="isLoading"
            [ngClass]="{ 'btn-primary' : loadFundsForm.valid && !isLoading}"
            [disabled]="loadFundsForm.invalid || isLoading"
            (click)="loadFunds()"
            mat-flat-button
        >
        <mat-icon fontIcon="add_circle"></mat-icon>  Topup
        </button>
        <button mat-raised-button class="btn-secondary rounded-pill" (click)="closeModal()">Cancel</button>
    </div>
</div>